import { JSX } from 'react'
import { Center, VStack, EmptyState, CenterProps } from '@chakra-ui/react'

import { RxCircleBackslash } from 'react-icons/rx'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Custom
(
	props: CenterProps
			& {
				title      : string
				description: string
				indicator  : JSX.Element

			},

)
:	JSX.Element
{
	return (
		<Center h="full" {...props}>
			<EmptyState.Root>
				<EmptyState.Content>
					<EmptyState.Indicator>{props.indicator}</EmptyState.Indicator>

					<VStack textAlign="center">
						<EmptyState.Title>{props.title}</EmptyState.Title>
						<EmptyState.Description>{props.description}</EmptyState.Description>

					</VStack>

				</EmptyState.Content>

			</EmptyState.Root>

		</Center>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Miss
(
	props: CenterProps
			& {
				title      : string
				description: string

			},
)
:	JSX.Element
{
	return (
		<Custom {...props} indicator={<RxCircleBackslash size="48" />} />

	)

}
